import { styled, theme } from "@theme/stitches.config"
import { keyframes } from "@stitches/react"

export const accordionOpen = keyframes({
    from: { height: 0 },
    to: { height: "var(--radix-accordion-content-height)" }
})

export const accordionClose = keyframes({
    from: { height: "var(--radix-accordion-content-height)" },
    to: { height: 0 }
})

export const Subtitle = styled("p", {
    fontFamily: theme.fonts.heading,
    fontSize: theme.fontSizes.desktopH6,
    color: theme.colors.N50,
    lineHeight: 1,
    textTransform: "uppercase",
    marginBottom: 8
})

export const Container = styled("div", {
    maxWidth: "calc(100% - 200px)",
    width: 1240,
    mx: "auto",
    "@lgDown": {
        maxWidth: "calc(100% - 100px)"
    },
    "@mdDown": {
        maxWidth: "calc(100% - 40px)"
    }
})

export const Title = styled("p", {
    fontFamily: theme.fonts.heading,
    fontSize: theme.fontSizes.desktopH2,
    color: theme.colors.white,
    lineHeight: 1.2,
    textTransform: "uppercase",
    "@mdDown": {
        fontSize: theme.fontSizes.mobileH2,
        mt: 10
    }
})
